import { batch } from 'react-redux';

import { handleErrors } from './ErrorActions';
import { setPanelLayoutConfig, unlockPanelLayoutConfig } from './PanelLayoutActions';
import * as documentApi from '../api/document';
import { PANEL_CONFIGURATIONS } from '../constants/PanelLayoutConstants';
import { createDocumentEntity } from '../form-designer/actions/form-manager.actions';
import { isEmpty } from '../utils/ramdaUtils';

export const VIEW_DOCUMENT = 'DocumentViewer/VIEW_DOCUMENT';
export const VIEW_DOCUMENT_SUCCESS = 'DocumentViewer/VIEW_DOCUMENT_SUCCESS';

export const GET_ACTIVE_DEVIATION_SUCCESS = 'DocumentViewer/GET_ACTIVE_DEVIATION_SUCCESS';
export const CLOSE_ACTIVE_DEVIATION_MESSAGE = 'DocumentViewer/CLOSE_ACTIVE_DEVIATION_MESSAGE';

export const CLEAR_DOCUMENT_VIEWER = 'CLEAR_DOCUMENT_VIEWER';

export const viewDocumentSuccess = (data) => ({
  type: VIEW_DOCUMENT_SUCCESS,
  payload: { data },
});

export const getActiveDeviationSuccess = (data) => ({
  type: GET_ACTIVE_DEVIATION_SUCCESS,
  payload: { data },
});

export const closeActiveDeviationMessage = () => ({
  type: CLOSE_ACTIVE_DEVIATION_MESSAGE,
});

export const clearDocumentViewer = () => ({ type: CLEAR_DOCUMENT_VIEWER });

export const viewDocument = ({
  docId,
  documentNumber,
  documentRevision,
  getLatestRevision,
  contentType,
  entityName,
}) => async (dispatch) => {
  dispatch({
    type: VIEW_DOCUMENT,
  });

  try {
    const apiData = await documentApi.getDocumentHeaderParams({
      docId,
      documentNumber,
      documentRevision,
      getLatestRevision,
      contentType,
      entityName,
    });

    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(viewDocumentSuccess(apiData.Result));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`viewDocument() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};

export const getActiveDeviation = ({ docId }) => async (dispatch) => {
  try {
    const apiData = await documentApi.getActiveDeviationForDocument({ docId });
    if (apiData.hasError) {
      dispatch(handleErrors(apiData.errors));
      return;
    }

    dispatch(getActiveDeviationSuccess(apiData.Result));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(`getActiveDeviation() failed: ${JSON.stringify(error)}`);
    dispatch(handleErrors(error));
  }
};

export const loadContent = ({
  documentData,
  entityType,
  docId,
  documentNumber,
  documentRevision,
  getLatestRevision,
  contentType,
  certification,
  formKey,
  formEntityName,
  itmId,
  isPortalContent,
  isBatchPrint,
}) => (dispatch) => {
  batch(() => {
    if (isEmpty(documentData)) {
      dispatch(
        viewDocument({
          entityName: entityType,
          docId,
          documentNumber,
          documentRevision,
          getLatestRevision,
          contentType,
        })
      );
    }

    const certificationData = Boolean(certification);

    if (!certificationData && !isPortalContent && !isBatchPrint) {
      dispatch(getActiveDeviation({ docId }));
    }

    if (formKey) {
      dispatch(
        createDocumentEntity({
          entityType: isPortalContent ? 'SS_DOC_SHARE_REVIEW_PRTL' : formEntityName,
          formKey,
          itmId,
          certificationData,
        })
      );
      dispatch(unlockPanelLayoutConfig());
      dispatch(setPanelLayoutConfig(PANEL_CONFIGURATIONS.LEFT_COLLAPSED));
    }
  });
};
